module.exports = __webpack_public_path__ + "static/img/over.3173f433.png";